import { QueryClient } from "@tanstack/react-query";
import { encryptAuthPhrase } from "./authUtils";

// Global session interceptor
function handleSessionExpiry(status) {
  if (status === 401 || status === 403) {
    try {
      localStorage.removeItem("app_session");
      localStorage.removeItem("SUPPLIER_ID");
      localStorage.removeItem("approverId");
      localStorage.removeItem("empId");
      localStorage.removeItem("status");
      localStorage.setItem("SESSION_EXPIRED_NOTICE", "1");
    } catch {}

    // Redirect to login
    if (typeof window !== "undefined") {
      window.location.href = "/supplier-login";
    }
  }
}

function getReadableErrorMessage(value, fallback = "Something went wrong") {
  if (value === null || value === undefined) {
    return fallback;
  }

  if (typeof value === "string") {
    const trimmedValue = value.trim();
    return trimmedValue || fallback;
  }

  if (value instanceof Error) {
    return getReadableErrorMessage(value.message, fallback);
  }

  if (Array.isArray(value)) {
    for (const entry of value) {
      const message = getReadableErrorMessage(entry, "");
      if (message) {
        return message;
      }
    }

    return fallback;
  }

  if (typeof value === "object") {
    const candidateFields = [
      value.message,
      value.error,
      value.description,
      value.msg,
      value.reason,
      value.details,
      value.result,
    ];

    for (const candidate of candidateFields) {
      const message = getReadableErrorMessage(candidate, "");
      if (message) {
        return message;
      }
    }

    try {
      return JSON.stringify(value);
    } catch {
      return fallback;
    }
  }

  return String(value);
}

async function throwIfResNotOk(res) {
  // Intercept 401/403 globally for session expiry
  handleSessionExpiry(res.status);

  if (!res.ok) {
    const text = (await res.text()) || res.statusText;
    throw new Error(`${res.status}: ${text}`);
  }
}
// Configure your API base URL here for external database integration

// const BASE_API_URL =
// import.meta.env.BASE_API_URL || "https://supplyco-erp.ndz.co.in:10101/";
const BASE_API_URL = import.meta.env.VITE_BASE_API_URL;
export default BASE_API_URL;

// https://supplyco-erp.ndz.co.in:10101/go/erp
// src/config/apiConfig.js
// const BASE_API_FULLURL =
//   import.meta.env.VITE_BASE_API_URL || "https://trial.supplycoerp.com:10101/";
//   // import.meta.env.VITE_BASE_API_URL || 'https://supplyco-erp.ndz.co.in:10101/';
//   export default BASE_API_FULLURL;

export async function apiRequest(method, url, data, methodname) {
  const tpauthphrase = encryptAuthPhrase();
  console.log(method, "method");

  const today = new Date();
  const dot = `${today.getFullYear()}${String(today.getMonth() + 1).padStart(2, "0")}${String(today.getDate()).padStart(2, "0")}`;
  const empId = localStorage.getItem("empId");
  const headers = {
    "Content-Type": "application/json",
    branchid: "1",
    methodname: methodname,
    source: "TP",
    dot: dot,
    userid: empId,
    tdauthcode: "b9a4f7d6-a039-4fbb-9265-8fb3ea0019bb",
    tpauthphrase: tpauthphrase,
  };
  //  ...(localStorage.getItem("SESSION_ID") && { sessionid: localStorage.getItem("SESSION_ID") })

  let fullUrl = `${BASE_API_URL}${url}`;

  try {
    const response = await fetch(fullUrl, {
      method,
      headers,
      body: data ? JSON.stringify(data) : undefined,
    });
    console.log(
      {
        method,
        headers,
        body: data ? JSON.stringify(data) : undefined,
      },
      "registerapidata",
    );
    await throwIfResNotOk(response);
    return response;
  } catch (error) {
    // console.error('API request failed:', error)
    if (!error.response) {
      error.isNetworkError = true;
      error.message = error.message || "Network error occurred";
    }

    throw error;
  }
}

export async function apiLogoutRequest(method, url, data, methodname) {
  const tpauthphrase = encryptAuthPhrase();
  console.log(method, "method");

  const today = new Date();
  const dot = `${today.getFullYear()}${String(today.getMonth() + 1).padStart(2, "0")}${String(today.getDate()).padStart(2, "0")}`;

  const headers = {
    "Content-Type": "application/json",
    // "branchid": "1",
    methodname: methodname,
    source: "TP",
    dot: dot,
    // "userid": "1",
    tdauthcode: "b9a4f7d6-a039-4fbb-9265-8fb3ea0019bb",
    tpauthphrase: tpauthphrase,
    // "sessionid" : sessionid,
  };
  //  ...(localStorage.getItem("SESSION_ID") && { sessionid: localStorage.getItem("SESSION_ID") })

  let fullUrl = `${BASE_API_URL}${url}`;

  try {
    const response = await fetch(fullUrl, {
      method,
      headers,
      body: data ? JSON.stringify(data) : undefined,
    });
    console.log(
      {
        method,
        headers,
        body: data ? JSON.stringify(data) : undefined,
      },
      "registerapidata",
    );
    await throwIfResNotOk(response);
    return response;
  } catch (error) {
    // console.error('API request failed:', error)
    if (!error.response) {
      error.isNetworkError = true;
      error.message = error.message || "Network error occurred";
    }
    throw error;
  }
}

export async function apiRequest2(method, url, data, methodname) {
  const tpauthphrase = encryptAuthPhrase();
  const today = new Date();
  const dot = `${today.getFullYear()}${String(today.getMonth() + 1).padStart(2, "0")}${String(today.getDate()).padStart(2, "0")}`;
  const empId = localStorage.getItem("empId");
  const headers = {
    "Content-Type": "application/json",
    branchid: "1",
    methodname: methodname,
    source: "TP",
    dot: dot,
    userid: empId,
    tdauthcode: "b9a4f7d6-a039-4fbb-9265-8fb3ea0019bb",
    tpauthphrase: tpauthphrase,
  };

  let fullUrl = `${BASE_API_URL}${url}`;
  // const effectiveMethod = data ? 'POST' : method;

  try {
    const response = await fetch(fullUrl, {
      method,
      headers,
      body: data ? JSON.stringify(data) : undefined,
    });

    console.log(
      {
        method,
        headers,
        body: data ? JSON.stringify(data) : undefined,
      },
      "registerapidata2",
    );
    await throwIfResNotOk(response);
    return response;
  } catch (error) {
    console.error("API request failed:", error);
    if (!error.response) {
      error.isNetworkError = true;
      error.message = error.message || "Network error occurred";
    }
    throw error;
  }
}

export async function apiGetRequest(url, data, methodname) {
  const tpauthphrase = encryptAuthPhrase();
  const today = new Date();
  const dot = `${today.getFullYear()}${String(today.getMonth() + 1).padStart(2, "0")}${String(today.getDate()).padStart(2, "0")}`;
  const empId = localStorage.getItem("empId");
  const headers = {
    "Content-Type": "application/json",
    branchid: "1",
    methodname: methodname,
    source: "TP",
    dot: dot,
    userid: empId,
    tdauthcode: "b9a4f7d6-a039-4fbb-9265-8fb3ea0019bb",
    tpauthphrase: tpauthphrase,
  };

  const fullUrl = `${BASE_API_URL}${url}`;

  console.log(methodname, "h1232");

  try {
    // Ensure data is properly formatted as an array
    const requestData = Array.isArray(data) ? data : [data];

    const response = await fetch(fullUrl, {
      method: "GET",
      headers: headers,
    });

    console.log("Request payload:", {
      url: fullUrl,
      method: "GET",
      headers,
      body: requestData,
    });

    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(`API Error: ${errorText}`);
    }
    return response;
  } catch (error) {
    console.error("Request failed:", error);
    throw error;
  }
}

//supplier item get apis
export async function apiGetRequest2(url, data, methodname) {
  const tpauthphrase = encryptAuthPhrase();
  const today = new Date();
  const dot = `${today.getFullYear()}${String(today.getMonth() + 1).padStart(2, "0")}${String(today.getDate()).padStart(2, "0")}`;
  const empId = localStorage.getItem("empId");
  const headers = {
    "Content-Type": "application/json",
    branchid: "1",
    methodname: methodname,
    source: "TP",
    dot: dot,
    userid: empId,
    tdauthcode: "b9a4f7d6-a039-4fbb-9265-8fb3ea0019bb",
    tpauthphrase: tpauthphrase,
  };

  const fullUrl = `${BASE_API_URL}${url}`;

  try {
    // Ensure data is properly formatted as an array
    const requestData = Array.isArray(data) ? data : [data];

    const response = await fetch(fullUrl, {
      method: "POST",
      headers: headers,
      body: JSON.stringify(requestData),
    });

    console.log("Request payload:", {
      url: fullUrl,
      method: "POST",
      headers,
      // body: requestData,
    });

    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(`API Error: ${errorText}`);
    }

    return response;
  } catch (error) {
    console.error("Request failed:", error);
    throw error;
  }
}

export async function apiGetDeatails(url, data, methodname) {
  const tpauthphrase = encryptAuthPhrase();
  const today = new Date();
  const dot = `${today.getFullYear()}${String(today.getMonth() + 1).padStart(2, "0")}${String(today.getDate()).padStart(2, "0")}`;
  const empId = localStorage.getItem("empId");
  const headers = {
    "Content-Type": "application/json",
    branchid: "1",
    methodname: methodname,
    source: "TP",
    dot: dot,
    userid: empId,
    tdauthcode: "b9a4f7d6-a039-4fbb-9265-8fb3ea0019bb",
    tpauthphrase: tpauthphrase,
  };

  const fullUrl = `${BASE_API_URL}${url}`;
  const requestData = Array.isArray(data) ? data : [data];

  const response = await fetch(fullUrl, {
    method: "POST",
    headers,
    body: JSON.stringify(requestData),
  });

  if (!response.ok) {
    const errorText = await response.text();

    let errorData = null;

    try {
      errorData = JSON.parse(errorText);
    } catch {
      errorData = null;
    }

    const errorMessage = getReadableErrorMessage(
      errorData?.tables?.result?.["0"].message,
    );

    console.log("errorText:", errorMessage);
    throw new Error(`${errorMessage}`);
  }

  return response;
}

export async function apiGetDepartmentLIst(path, data, methodName) {
  const url = `https://trial.supplycoerp.com:10101/${path}`;

  return fetch(url, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      methodname: methodName, // 🔹 REQUIRED HEADER
    },
    body: JSON.stringify(data), // 🔹 Send formatted ERP body
  });
}

// export async function apiGetSupplieritem(url, data, methodname) {
//   const tpauthphrase = encryptAuthPhrase();
//   const today = new Date();
//   const dot = `${today.getFullYear()}${String(today.getMonth() + 1).padStart(2, '0')}${String(today.getDate()).padStart(2, '0')}`;

//   const headers = {
//     "Content-Type": "application/json",
//     branchid: "1",
//     methodname: methodname,
//     source: "TP",
//     dot: dot,
//     userid: "1",
//     tdauthcode: "b9a4f7d6-a039-4fbb-9265-8fb3ea0019bb",
//     tpauthphrase: tpauthphrase,
//   };

//   const fullUrl = `${BASE_API_URL}${url}`;

//   try {
//     // Always send as array
//     const requestData = Array.isArray(data) ? data : [data];

//     const response = await fetch(fullUrl, {
//       method: "GET", // ✅ change to POST
//       headers,
//       body: JSON.stringify(requestData),
//     });

//     console.log("Request payload:", {
//       url: fullUrl,
//       method: "GET",
//       headers,
//       // body: requestData,
//     });

//     if (!response.ok) {
//       const errorText = await response.text();
//       throw new Error(`API Error: ${errorText}`);
//     }

//     return response; // let caller .json() it
//   } catch (error) {
//     console.error("Request failed:", error);
//     throw error;
//   }
// }

export async function apiGetSupplieritem(url, data, methodname) {
  const tpauthphrase = encryptAuthPhrase();
  const today = new Date();
  const dot = `${today.getFullYear()}${String(today.getMonth() + 1).padStart(
    2,
    "0",
  )}${String(today.getDate()).padStart(2, "0")}`;
  const empId = localStorage.getItem("empId");
  const headers = {
    "Content-Type": "application/json",
    branchid: "1",
    methodname: methodname,
    source: "TP",
    dot: dot,
    userid: empId,
    tdauthcode: "b9a4f7d6-a039-4fbb-9265-8fb3ea0019bb",
    tpauthphrase: tpauthphrase,
  };

  // ✅ Convert data to query string
  const queryParams = new URLSearchParams();

  // If `data` is an array of objects, flatten first
  const dataArray = Array.isArray(data) ? data : [data];
  dataArray.forEach((item) => {
    for (const key in item) {
      queryParams.append(key, item[key]);
    }
  });

  // ✅ Build full URL with query string
  const fullUrl = `${BASE_API_URL}${url}?${queryParams.toString()}`;

  try {
    const response = await fetch(fullUrl, {
      method: "GET",
      headers,
    });

    console.log("Request payload:", {
      url: fullUrl,
      method: "GET",
      headers,
    });

    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(`API Error: ${errorText}`);
    }

    // ✅ Let caller parse .json() or do it here
    return await response.json();
  } catch (error) {
    console.error("Request failed:", error);
    throw error;
  }
}

export async function apiGetuploadRequest(url, data, methodname) {
  const tpauthphrase = encryptAuthPhrase();
  const today = new Date();
  const dot = `${today.getFullYear()}${String(today.getMonth() + 1).padStart(2, "0")}${String(today.getDate()).padStart(2, "0")}`;
  const empId = localStorage.getItem("empId");
  const headers = {
    "Content-Type": "application/json",
    branchid: "1",
    methodname: methodname,
    source: "TP",
    dot: dot,
    userid: empId,
    tdauthcode: "b9a4f7d6-a039-4fbb-9265-8fb3ea0019bb",
    tpauthphrase: tpauthphrase,
  };

  const fullUrl = `${BASE_API_URL}${url}`;

  try {
    // Ensure data is properly formatted as an array
    const requestData = Array.isArray(data) ? data : [data];

    const response = await fetch(fullUrl, {
      method: "POST",
      headers: headers,
      body: JSON.stringify(requestData),
    });

    console.log("Request payload:", {
      url: fullUrl,
      method: "POST",
      headers,
      body: requestData,
    });

    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(`API Error: ${errorText}`);
    }

    return response;
  } catch (error) {
    console.error("Request failed:", error);
    throw error;
  }
}

// Add to your lib/queryClient.js
export async function apiUploadDocument(
  file,
  methodname,
  fieldName,
  documentNumber = "",
) {
  const tpauthphrase = encryptAuthPhrase();
  const today = new Date();
  const dot = `${today.getFullYear()}${String(today.getMonth() + 1).padStart(2, "0")}${String(today.getDate()).padStart(2, "0")}`;
  const id = localStorage.getItem("SUPPLIER_ID");
  const empId = localStorage.getItem("empId");
  // Create FormData for file upload
  const formData = new FormData();
  formData.append("file", file);
  formData.append("field_name", fieldName);
  formData.append("document_number", documentNumber);
  formData.append("id", id);

  const headers = {
    branchid: "1",
    methodname: "acc.party.saveparty",
    source: "TP",
    dot: dot,
    userid: empId,
    tdauthcode: "b9a4f7d6-a039-4fbb-9265-8fb3ea0019bb",
    tpauthphrase: tpauthphrase,
  };

  try {
    const response = await fetch(`${BASE_API_URL}go/erp`, {
      method: "POST",
      headers,
      body: formData,
    });

    await throwIfResNotOk(response);
    return response.json();
  } catch (error) {
    console.error("Document upload failed:", error);
    throw error;
  }
}

export async function apiRemoveDocument(fieldName) {
  const id = localStorage.getItem("SUPPLIER_ID");
  const data = formatDocumentData({
    id,
    field_name: fieldName,
    methodName: "acc.party.removedocument",
  });

  return apiRequest2("POST", "go/erp", data, "acc.party.removedocument");
}

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      staleTime: 15_000,
    },
  },
});
export async function apiGetRequest3(url, data, methodname) {
  const tpauthphrase = encryptAuthPhrase();
  const today = new Date();
  const dot = `${today.getFullYear()}${String(today.getMonth() + 1).padStart(2, "0")}${String(today.getDate()).padStart(2, "0")}`;
  const empId = localStorage.getItem("empId");
  const headers = {
    "Content-Type": "application/json",
    branchid: "1",
    methodname: methodname,
    source: "TP",
    dot: dot,
    userid: empId,
    tdauthcode: "b9a4f7d6-a039-4fbb-9265-8fb3ea0019bb",
    tpauthphrase: tpauthphrase,
  };

  const fullUrl = `${BASE_API_URL}${url}`;
  const requestData = Array.isArray(data) ? data : [data];

  const response = await fetch(fullUrl, {
    method: "POST",
    headers,
    body: JSON.stringify(requestData),
  });

  if (!response.ok) {
    const errorText = await response.text();

    let errorData = null;

    try {
      errorData = JSON.parse(errorText);
    } catch {
      errorData = null;
    }

    const errorMessage = getReadableErrorMessage(
      errorData?.tables?.result?.["0"].message,
    );

    console.log("errorText:", errorMessage);
    throw new Error(`${errorMessage}`);
  }

  return response;
}
